import api from './api';

const financeiroService = {
  simular: async (dados) => {
    try {
      const response = await api.post('/financeiro/simular', dados);
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao realizar simulação financeira';
    }
  },
  obterProjecaoMensal: async () => {
    try {
      const response = await api.get('/financeiro/projecao');
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao buscar projeção financeira mensal';
    }
  }
};

export default financeiroService;